import { useState, type FormEvent } from 'react'
import { useLocation } from 'react-router-dom'

import { leaveTo, sameSitePath, signInLinkUrl, signInUrl } from './entry'
import './signedOut.css'

/**
 * What a visitor without a session sees instead of the app shell.
 *
 * It carries no tenant branding: a signed-out browser has no session, so the
 * app does not know whose tenant this is and must not guess. The product mark
 * and the footer credit are all it may show.
 */
export function SignedOutPage() {
  const location = useLocation()
  const returnTo = sameSitePath(location.pathname, location.search)
  const [email, setEmail] = useState('')

  function requestLink(event: FormEvent) {
    event.preventDefault()
    const address = email.trim()
    if (!address) return
    leaveTo(signInLinkUrl(address, returnTo))
  }

  return (
    <div className="ci-signed-out">
      <main className="ci-signed-out__card" aria-labelledby="ci-signed-out-title">
        <p className="ci-signed-out__mark">
          <span className="ci-signed-out__mark-tmt">TmT</span> Competition Insights
        </p>
        <h1 id="ci-signed-out-title">Sign in to continue</h1>
        <p className="ci-signed-out__lead">
          Your analytics, insights and automation for this organisation. You need to be signed in to see
          them.
        </p>

        <a className="ci-button ci-signed-out__primary" data-variant="primary" href={signInUrl(returnTo)}>
          Sign in
        </a>

        <p className="ci-signed-out__divider">
          <span>or</span>
        </p>

        <form className="ci-signed-out__link-form" aria-label="Email me a sign-in link" onSubmit={requestLink}>
          <label htmlFor="ci-signed-out-email">Email address</label>
          <input
            id="ci-signed-out-email"
            type="email"
            name="email"
            required
            autoComplete="email"
            placeholder="you@yourcompany.co.uk"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
          <button type="submit" className="ci-button">
            Email me a sign-in link
          </button>
        </form>

        <p className="ci-signed-out__help">
          No account yet? Ask an Owner or Administrator of your organisation to invite you.
        </p>
      </main>
      <footer className="ci-signed-out__footer">Powered by TmT Competition Insights</footer>
    </div>
  )
}
